import clsx from 'clsx';
import React, { useEffect } from 'react';

import Button from '@/src/components/common/Elements/Button/Button';
import { useToggle } from '@/src/hooks/useToggle';

import FromInput from '../../EmailEditor/FromInput';
import RecipientInput from '../../EmailEditor/RecipientInput';
import SubjectInput from '../Fields/SubjectInput/SubjectInput';

const EmailHeadingInput = ({
  isReply,
  projectId,
  toRecipients,
  ccRecipients,
  fromEmail,
  subject = '',
  setSubject = null,
  setToRecipients,
  setCcRecipients,
  setFromEmail,
}) => {
  const [isShowCc, toggleShowCc] = useToggle(ccRecipients.length > 0);

  useEffect(() => {
    toggleShowCc(ccRecipients.length > 0);
  }, [ccRecipients.length, toggleShowCc]);

  const handleSubjectInput = (event: React.FormEvent<HTMLInputElement>) => {
    setSubject?.((event.target as HTMLInputElement).value);
  };

  const handleBlur = (value: string, tags: any[]) => {
    if (value.trim().length > 0 || tags.length > 0) return;
    toggleShowCc(false);
  };

  const handleClickCc = () => {
    toggleShowCc(true);
  };

  return (
    <div
      className={clsx(
        'container--replyBoxHeader',
        'tw-px-[20px] tw-pt-[20px] tw-pb-[10px]',
        'tw-shadow-[inset_0px_-1px_0px_#EEEEEE]'
      )}
    >
      <RecipientInput
        projectId={projectId}
        fieldLabel={`To`}
        recipients={toRecipients}
        setRecipients={setToRecipients}
        isRequired={true}
        LastComponentSlot={
          !isShowCc ? (
            <Button
              onClick={handleClickCc}
              buttonClassSettings={{ variant: 'unstyled' }}
              className="tw-font-brandonTextMedium tw-font-medium tw-text-cfo-black"
            >
              Cc
            </Button>
          ) : null
        }
      />
      {isShowCc && (
        <RecipientInput
          projectId={projectId}
          fieldLabel={`Cc`}
          recipients={ccRecipients}
          setRecipients={setCcRecipients}
          onBlur={handleBlur}
        />
      )}
      {!isReply && (
        <FromInput
          projectId={projectId}
          fieldLabel={`From`}
          fromEmail={fromEmail}
          setFromEmail={setFromEmail}
          isRequired={true}
        />
      )}
      {!isReply && <SubjectInput subject={subject} onInput={handleSubjectInput} />}
    </div>
  );
};

export default EmailHeadingInput;
